export const translations = {
  en: {
    app_name: "TippTop",
    tagline: "Predict matches. Outsmart friends.",
    continue_google: "Continue with Google",
    continue_yandex: "Continue with Yandex ID",
    continue_mailru: "Mail.ru",
    login_with: "or",
    fifa_world_cup: "FIFA World Cup 2026",
    login_hero_line1: "TippTop",
    login_hero_line2: "World Cup.",
    login_hero_sub: "A private prediction game for you and your crew. Pick scores, climb the leaderboard, talk trash.",
    join_group_message: "Join \"{groupName}\" on TippTop! Use code: {code}",
    join_group_subject: "Join my TippTop group",
    nav_my_tips: "My Tips",
    nav_groups: "Groups",
    nav_leaderboard: "Ranks",
    nav_rules: "Rules",
    nav_standings: "Standings",
    logout: "Log out",
    total: "Total",
    current_round: "Current round",
    points: "Points",
    rank: "Rank",
    countdown: "Next kickoff",
    days: "Days",
    hours: "Hrs",
    minutes: "Min",
    seconds: "Sec",
    locked: "Locked",
    starts_in: "Kickoff in",
    same_tip: "% picked the same",
    be_first: "Be the first to tip",
    submit: "Submit tip",
    saved: "Saved",
    saving: "Saving…",
    not_tipped: "Not Tipped",
    your_groups: "Your groups",
    create_group: "Create group",
    join_group: "Join with code",
    group_name: "Group name",
    group_message: "Message to members",
    group_message_hint: "Shown to all members. Tell them what this group is about.",
    access: "Access",
    private_group: "Private group",
    private_group_hint: "Members join via invite code only.",
    invite_code: "Invite code",
    share_success: "Share your luck!",
    no_groups_title: "No groups yet",
    no_groups_sub: "Start a group with your friends or join one with a code.",
    cancel: "Cancel",
    save: "Save",
    join: "Join",
    copy_link: "Copy link",
    copied: "Copied!",
    leaderboard_title: "Global Rankings",
    leaderboard_sub: "Top predictors this tournament",
    rules_title: "How scoring works",
    rule_exact: "Exact score",
    rule_exact_desc: "Nail the final score and bag the full haul.",
    rule_diff: "Goal difference",
    rule_diff_desc: "Miss the score but get the margin right.",
    rule_home: "Home team goals",
    rule_home_desc: "Correctly predict the home team's score.",
    rule_away: "Away team goals",
    rule_away_desc: "Correctly predict the away team's score.",
    pts: "pts",
    of_5: "of 5",
    kickoff_label: "Kickoff",
    you: "You",
    no_matches: "No matches in this round yet",
    matches: "Matches",
    select_round: "Select round",
    close: "Close",
    language: "Language",
    english: "English",
    russian: "Русский",
    tournament: "Tournament",
    choose_tournament: "Choose tournament",
    most_popular: "Most popular",
    members: "members",
    empty_leaderboard: "No predictions scored yet.",
    invite_friends: "Invite friends",
    round: "Round",
    rounds: "Rounds",
    top_of_tournament: "Top of the leaderboard",
    players: "players",
    everyone_s_tips: "Everyone's tips",
    tap_to_see_tips: "Tap to see all tips",
    tips_count: "tips",
    pending: "Pending",
    actual: "Actual",
    no_bets_yet: "No bets yet.",
    no_bets_on_match: "No one has tipped yet.",
    open: "Open",
    open_full_board: "Full leaderboard",
    select_group: "Switch group",
    manage_groups: "Manage groups",
    no_active_group: "No group selected",
    delete_group: "Delete group",
    delete_group_confirm: "Delete this group? Members will lose access and this can't be undone.",
    remove_member: "Remove member",
    remove_member_confirm: "Remove {name} from the group?",
    could_not_remove_member: "Could not remove member",
    manage_members: "Manage Members",
    delete: "Delete",
    privacy_policy: "Privacy Policy",
    account_settings: "Account Settings",
    welcome_title: "Welcome to TippTop!",
    welcome_desc: "Please confirm or choose a display name. This will be visible on leaderboards.",
    update_name_desc: "Update your display name for leaderboards.",
    display_name: "Display Name",
    name_placeholder: "e.g. John Doe",
    lets_go: "Let's Go",
    name_empty_error: "Name cannot be empty",
    name_save_error: "Failed to save profile. Please try again.",
    email_placeholder: "Enter your email",
    send_link: "Send Link",
    magic_link_sent: "Check your email for the magic link!",
    tournament_standings: "Tournament Standings",
    standings_working_hard: "We're working hard to bring you the live standings for all active tournaments. Check back soon!",
    tab_groups: "Groups",
    tab_playoffs: "Playoffs",
    played_short: "P",
    goals_difference_short: "GD",
    points_short: "PTS",
    no_active_tournament: "No active tournament",
    select_group_instructions: "Select a group from the header to view standings.",
    scoring: "Scoring",
    max_haul: "Max haul",
    rules_max_haul_desc: "Your exact score is worth the full <strong class='text-white'>5 points</strong>: goal-difference bonus <strong class='text-[#41a42b]'> +3</strong>, plus <strong class='text-[#41a42b]'>+1</strong> for each team's goals.",
    examples: "Examples",
    actual: "Actual",
    tip: "Tip",
    could_not_create_group: "Could not create group",
    could_not_join: "Could not join",
    placeholder_champions_room: "The Champions Room",
    could_not_delete_group: "Could not delete group",
    loading_dots: "Loading…",
    bonus_bet_title: "Champion Prediction",
    bonus_bet_reward: "+20 PTS",
    bonus_bet_desc: "Predict the tournament winner before kickoff.",
    bonus_bet_select_winner: "Select tournament winner...",
    bonus_bet_locked_desc: "Prediction locked.",
    bonus_bet_points_won: "Won +20 points",
    bonus_bet_points_lost: "0 points",
    bonus_bet_no_prediction: "No prediction made",
    rule_bonus: "Tournament Champion",
    rule_bonus_desc: "Predict the tournament winner before kickoff. Locks 15 minutes before the very first match.",
    rules_playoffs_double_title: "Playoffs Double Points",
    rules_playoffs_double_desc: "All match prediction points are doubled during the knockout rounds (e.g., exact score yields 10 points instead of 5, difference yields 6, etc.).",
    rules_max_haul_four_desc: "You can earn up to 4 points per match: <strong class='text-white'>+1</strong> for exact home goals, <strong class='text-[#41a42b]'>+1</strong> for exact away goals, <strong class='text-[#41a42b]'>+1</strong> for goal difference, and <strong class='text-[#41a42b]'>+1</strong> for the winner or tie.",
    rule_four_home: "Home Goals",
    rule_four_home_desc: "Correctly predict the exact number of goals the home team scores.",
    rule_four_away: "Away Goals",
    rule_four_away_desc: "Correctly predict the exact number of goals the away team scores.",
    rule_four_diff: "Goal Difference",
    rule_four_diff_desc: "Correctly predict the difference in goals between the teams.",
    rule_four_winner: "Winner / Tie",
    rule_four_winner_desc: "Correctly predict which team wins, or if the match ends in a tie.",
    example_diff_winner: "Diff+Winner",
    example_away_winner: "Away+Winner",
    example_winner: "Winner",
    example_diff_tie: "Diff+Tie",
    of: "of",
    team: "Team",
    tbd: "TBD",
    stage_final: "Final",
    stage_third_place: "3rd Place",
    signing_in_title: "TippTop — Signing in",
    signing_in_desc: "Signing you in…",
    error_saving_prediction: "Error saving prediction",
    could_not_load: "Could not load",
    tips: "Tips",
    scoring_system: "Scoring System",
    scoring_system_classic_title: "Classic (Max 5)",
    scoring_system_classic_desc: "Exact match 5 pts, correct diff 3 pts, or 1 pt per team score.",
    scoring_system_four_point_title: "4-Point System",
    scoring_system_four_point_desc: "1 pt each for: home goals, away goals, difference, and outcome.",
    after_extra_time: "After extra time",
    penalties: "PEN",
    main_time: "Main time",
  },
  ru: {
    app_name: "TippTop",
    tagline: "Предсказывай матчи. Обыгрывай друзей.",
    continue_google: "Войти через Google",
    continue_yandex: "Войти через Яндекс ID",
    continue_mailru: "Mail.ru",
    login_with: "или",
    fifa_world_cup: "Чемпионат мира 2026",
    login_hero_line1: "TippTop",
    login_hero_line2: "Чемпионат.",
    login_hero_sub: "Приватная игра прогнозов для тебя и твоих друзей. Делай ставки, поднимайся в рейтинге, побеждай.",
    join_group_message: "Присоединяйся к группе \"{groupName}\" в TippTop! Используй код: {code}",
    join_group_subject: "Присоединяйся к моей группе в TippTop",
    nav_my_tips: "Мои прогнозы",
    nav_groups: "Группы",
    nav_leaderboard: "Рейтинг",
    nav_rules: "Правила",
    nav_standings: "Таблицы",
    logout: "Выйти",
    total: "Всего",
    current_round: "Текущий тур",
    points: "Очки",
    rank: "Место",
    countdown: "До матча",
    days: "Дни",
    hours: "Часы",
    minutes: "Мин",
    seconds: "Сек",
    locked: "Закрыто",
    starts_in: "До начала",
    same_tip: "% угадали так же",
    be_first: "Будь первым",
    submit: "Сделать прогноз",
    saved: "Сохранено",
    saving: "Сохр…",
    not_tipped: "Нет прогноза",
    your_groups: "Ваши группы",
    create_group: "Создать группу",
    join_group: "Присоединиться по коду",
    group_name: "Название группы",
    group_message: "Сообщение для участников",
    group_message_hint: "Будет видно всем участникам. Опишите цель группы.",
    access: "Доступ",
    private_group: "Приватная группа",
    private_group_hint: "Вход только по коду приглашения.",
    invite_code: "Код приглашения",
    share_success: "Поделитесь успехом!",
    no_groups_title: "Пока нет групп",
    no_groups_sub: "Создайте свою группу или присоединитесь по коду.",
    cancel: "Отмена",
    save: "Сохранить",
    join: "Войти",
    copy_link: "Скопировать ссылку",
    copied: "Скопировано!",
    leaderboard_title: "Глобальный рейтинг",
    leaderboard_sub: "Лучшие прогнозисты турнира",
    rules_title: "Как считаются очки",
    rule_exact: "Точный счёт",
    rule_exact_desc: "Угадайте финальный счёт — максимум очков.",
    rule_diff: "Разница мячей",
    rule_diff_desc: "Счёт не угадали, но разницу — да.",
    rule_home: "Голы хозяев",
    rule_home_desc: "Угадали число голов домашней команды.",
    rule_away: "Голы гостей",
    rule_away_desc: "Угадали число голов гостей.",
    pts: "очк",
    of_5: "из 5",
    kickoff_label: "Начало",
    you: "Вы",
    no_matches: "В этом туре пока нет матчей",
    matches: "Матчи",
    select_round: "Выберите тур",
    close: "Закрыть",
    language: "Язык",
    english: "English",
    russian: "Русский",
    tournament: "Турнир",
    choose_tournament: "Выбери турнир",
    most_popular: "Популярный",
    members: "участн.",
    empty_leaderboard: "Прогнозы ещё не засчитаны.",
    invite_friends: "Пригласить",
    round: "Тур",
    rounds: "Туры",
    top_of_tournament: "Топ рейтинга",
    players: "игроков",
    everyone_s_tips: "Прогнозы всех",
    tap_to_see_tips: "Показать все прогнозы",
    tips_count: "прогноз.",
    pending: "Ожидает",
    actual: "Итог",
    no_bets_yet: "Пока прогнозов нет.",
    no_bets_on_match: "Никто ещё не прогнозировал.",
    open: "Открыть",
    open_full_board: "Весь рейтинг",
    select_group: "Сменить группу",
    manage_groups: "Управление группами",
    no_active_group: "Группа не выбрана",
    delete_group: "Удалить группу",
    delete_group_confirm: "Удалить эту группу? Участники потеряют доступ, отменить нельзя.",
    remove_member: "Исключить участника",
    remove_member_confirm: "Исключить {name} из группы?",
    could_not_remove_member: "Не удалось исключить участника",
    manage_members: "Участники",
    delete: "Удалить",
    privacy_policy: "Политика конфиденциальности",
    account_settings: "Настройки аккаунта",
    welcome_title: "Добро пожаловать в TippTop!",
    welcome_desc: "Пожалуйста, подтвердите или выберите имя. Оно будет отображаться в рейтингах.",
    update_name_desc: "Обновите ваше имя для отображения в рейтингах.",
    display_name: "Имя",
    name_placeholder: "например, Иван Иванов",
    lets_go: "Поехали!",
    name_empty_error: "Имя не может быть пустым",
    name_save_error: "Не удалось сохранить профиль. Попробуйте еще раз.",
    email_placeholder: "Введите email",
    send_link: "Войти",
    magic_link_sent: "Ссылка для входа отправлена на почту!",
    tournament_standings: "Таблицы турниров",
    standings_working_hard: "Мы усердно работаем, чтобы показать вам таблицы для всех активных турниров. Загляните позже!",
    tab_groups: "Группы",
    tab_playoffs: "Плей-офф",
    played_short: "И",
    goals_difference_short: "РМ",
    points_short: "О",
    no_active_tournament: "Активный турнир не выбран",
    select_group_instructions: "Выберите группу в шапке, чтобы увидеть таблицы.",
    scoring: "Начисление очков",
    max_haul: "Максимум",
    rules_max_haul_desc: "Точный счёт приносит полные <strong class='text-white'>5 очков</strong>: бонус за разницу мячей <strong class='text-[#41a42b]'>+3</strong>, плюс по <strong class='text-[#41a42b]'>+1</strong> за голы каждой команды.",
    examples: "Примеры",
    actual: "Итог",
    tip: "Прогноз",
    could_not_create_group: "Не удалось создать группу",
    could_not_join: "Не удалось войти",
    placeholder_champions_room: "Комната чемпионов",
    could_not_delete_group: "Не удалось удалить группу",
    loading_dots: "Загрузка…",
    bonus_bet_title: "Прогноз на чемпиона",
    bonus_bet_reward: "+20 ОЧК",
    bonus_bet_desc: "Предскажи победителя турнира до его начала.",
    bonus_bet_select_winner: "Выбери победителя турнира...",
    bonus_bet_locked_desc: "Прогноз закрыт.",
    bonus_bet_points_won: "Выиграно +20 очков",
    bonus_bet_points_lost: "0 очков",
    bonus_bet_no_prediction: "Прогноз не сделан",
    rule_bonus: "Победитель турнира",
    rule_bonus_desc: "Предскажи победителя турнира до его начала. Закрывается за 15 минут до первого матча.",
    rules_playoffs_double_title: "Удвоение очков в плей-офф",
    rules_playoffs_double_desc: "В раундах плей-офф (на вылет) все набранные за прогноз очки удваиваются (например, точный счёт приносит 10 очков вместо 5, разница — 6 и т.д.).",
    rules_max_haul_four_desc: "Вы можете набрать до 4 очков за матч: <strong class='text-white'>+1</strong> за точные голы хозяев, <strong class='text-[#41a42b]'>+1</strong> за точные голы гостей, <strong class='text-[#41a42b]'>+1</strong> за разницу мячей и <strong class='text-[#41a42b]'>+1</strong> за исход (победитель/ничья).",
    rule_four_home: "Голы хозяев",
    rule_four_home_desc: "Точное число голов хозяев поля.",
    rule_four_away: "Голы гостей",
    rule_four_away_desc: "Точное число голов гостей.",
    rule_four_diff: "Разница мячей",
    rule_four_diff_desc: "Угаданная разница мячей между командами.",
    rule_four_winner: "Исход матча",
    rule_four_winner_desc: "Угаданный победитель или ничейный результат.",
    example_diff_winner: "Разница+Исход",
    example_away_winner: "Гости+Исход",
    example_winner: "Исход",
    example_diff_tie: "Разница+Ничья",
    of: "из",
    team: "Команда",
    tbd: "Определится",
    stage_final: "Финал",
    stage_third_place: "3-е место",
    signing_in_title: "TippTop — Вход в систему",
    signing_in_desc: "Выполняется вход…",
    error_saving_prediction: "Ошибка сохранения прогноза",
    could_not_load: "Не удалось загрузить",
    tips: "Прогнозы",
    scoring_system: "Система начисления очков",
    scoring_system_classic_title: "Классическая (макс. 5)",
    scoring_system_classic_desc: "Точный счет — 5 очк, разница — 3 очк, голы команды — по 1 очк.",
    scoring_system_four_point_title: "4-очковая система",
    scoring_system_four_point_desc: "По 1 очк за: голы хозяев, голы гостей, разницу и исход.",
    after_extra_time: "после д.в.",
    penalties: "ПЕН",
    main_time: "Основное время",
  },
};

export function t(locale, key) {
  return translations[locale]?.[key] ?? translations.en[key] ?? key;
}
